import React from 'react';

/*
    - components
*/
import AuthCheckComponent from './chat-list/authCheck';
import HotelInfoComponent from './chat-list/hotelInfo';
import InvoiceComponent from './chat-list/invoice';
import NewRequestComponent from './chat-list/newRequest';
import RemoveRequestComponent from './chat-list/removeRequest';
import SelectRequestComponent from './chat-list/selectRequest';
import SelectReserveComponent from './chat-list/selectReserve';
import SharedComponent from './chat-list/shared';

const ChatList = ({ reservesResult, createTicketResut, officialInvoiceLinkResult, hotelInfoResult, requestType, selectedReserve, selectedService, ticket }) => {

    return (

        <React.Fragment>

            <NewRequestComponent />

            {requestType !== 'newRequest' && requestType.split(',')[1] !== 'removeRequest' &&
                <SelectRequestComponent
                    requestType={requestType} />
            }

            {requestType.split(',')[2] === 'reserveList' &&
                <AuthCheckComponent
                    reservesResult={reservesResult}
                    requestType={requestType} />
            }

            {(requestType.split(',')[3] === 'selectReserve' || selectedService === 'awaiting' || selectedService === 'pending') &&
                <SelectReserveComponent
                    requestType={requestType}
                    selectedReserve={selectedReserve}
                    selectedService={selectedService} />
            }

            {(requestType.split(',')[4] === 'modifyRoomFinished' || requestType.split(',')[4] === 'cancelFinished' || requestType.split(',')[4] === 'modifyDateFinished' || requestType.split(',')[4] === 'extraPassengerFinished' || requestType.split(',')[4] === 'halfChargeFinished' || requestType.split(',')[4] === 'modifyPassengerFinished' || requestType.split(',')[4] === 'transferFinished') &&
                <SharedComponent
                    createTicketResut={createTicketResut}
                    requestType={requestType}
                    selectedReserve={selectedReserve}
                    ticket={ticket} />
            }

            {requestType.split(',')[4] === 'hotelInfoFinished' &&
                <HotelInfoComponent
                    hotelInfoResult={hotelInfoResult}
                    requestType={requestType} />
            }

            {requestType.split(',')[4] === 'invoiceFinished' &&
                <InvoiceComponent
                    createTicketResut={createTicketResut}
                    officialInvoiceLinkResult={officialInvoiceLinkResult}
                    requestType={requestType}
                    selectedReserve={selectedReserve} />
            }

            {requestType.split(',')[3] === 'removeRequestFinished' &&
                <RemoveRequestComponent
                    requestType={requestType} />
            }

        </React.Fragment>

    );

}

export default ChatList;